var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPlace = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.513,
    height: 22.883,
    viewBox: "0 0 18.513 22.883",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#96b4b6;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.738,3.979a9.239,9.239,0,0,0-15.191,0,9.241,9.241,0,0,0-1.076,8.514,7.277,7.277,0,0,0,1.341,2.214L57.533,22.6a.8.8,0,0,0,1.218,0l6.719-7.892A7.285,7.285,0,0,0,66.812,12.5,9.242,9.242,0,0,0,65.738,3.979Zm-.425,7.959a5.707,5.707,0,0,1-1.055,1.729l0,0-6.112,7.178-6.115-7.183a5.711,5.711,0,0,1-1.057-1.734,7.644,7.644,0,0,1,.893-7.043,7.639,7.639,0,0,1,12.558,0A7.645,7.645,0,0,1,65.313,11.937Z",
    transform: "translate(-48.886)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.776 4.747)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M160.235,106.219a4.481,4.481,0,1,0,4.481,4.481A4.486,4.486,0,0,0,160.235,106.219Zm0,7.361a2.88,2.88,0,1,1,2.88-2.88A2.884,2.884,0,0,1,160.235,113.58Z",
    transform: "translate(-155.754 -106.219)"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlace, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/place.3a29614a.svg";
export { ForwardRef as ReactComponent };